import React, { useState, useEffect } from 'react'
import env, { environment } from '@/main/config/env'
import { useTheme } from '@/presentation/hooks'
import { HStack, Text, Chip } from '@/presentation/components'
import { version } from '../../../../package.json'

export const OutdatedError: React.FC = () => {
  const theme = useTheme()
  const [lastAppVersion, setLastAppVersion] = useState('x.x.x')
  const [lastIntegraVersion, setLastIntegraVersion] = useState('x.x.x')
  const [appOutdated, setAppOutdated] = useState(false)
  const [integraOutdated, setIntegraOutdated] = useState(false)

  const getVersion = async (url: string): Promise<string> => {
    try {
      const version = await fetch(url)
      return await version.text()
    } catch (error) {
      console.error(error)
      return 'x.x.x'
    }
  }

  useEffect(() => {
    const getAppVersion = async (): Promise<void> => {
      const fileVersionName = 'PortalServiceNewVersion.txt'
      const lastAppVersion = await getVersion(`${env.API_PROJETOS}Projetos/${fileVersionName}`)
      setLastAppVersion(lastAppVersion)

      const currentAppVersionValue = parseInt(version.replaceAll('.', ''))
      const lastAppVersionValue = parseInt(lastAppVersion.replaceAll('.', ''))
      if (isNaN(lastAppVersionValue)) {
        setAppOutdated(false)
      } else {
        setAppOutdated(lastAppVersionValue > currentAppVersionValue)
      }
    }

    const getIntegraVersion = async (): Promise<void> => {
      const fileVersionName = 'IntegraServiceWebApiVersion.txt'
      const baseUrl = environment === 'development' ? env.API_URL : '/'
      const lastIntegraVersion = await getVersion(`${env.API_PROJETOS}atualizador/integra-service-web-api/latest/${fileVersionName}`)
      const currentIntegraVersion = await getVersion(`${baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`}${fileVersionName}`)
      setLastIntegraVersion(lastIntegraVersion)

      const currentIntegraVersionValue = parseInt(currentIntegraVersion.replaceAll('.', ''))
      const lastIntegraVersionValue = parseInt(lastIntegraVersion.replaceAll('.', ''))
      if (isNaN(lastIntegraVersionValue) || isNaN(currentIntegraVersionValue)) {
        setIntegraOutdated(false)
      } else {
        setIntegraOutdated(lastIntegraVersionValue > currentIntegraVersionValue)
      }
    }

    void getAppVersion()
    void getIntegraVersion()
  }, [])

  const makeAppOutdated = (): JSX.Element =>
    <HStack justify='center' items='center' style={{ backgroundColor: theme.colors.errorContainer }}>
      <Chip text={`${(appOutdated ? 'Portal' : 'IntegraService')} desatualizado`} color={theme.colors.error} />
      <Text variant="subtitle1" style={{ 
        padding: 12,
        fontWeight: '500',
        textTransform: 'uppercase', color: theme.colors.error
      }} >
        Existe uma versão nova disponível, contate o suporte para atualização
      </Text>
      <HStack spacing={8}>
        <Chip 
          variant='outlined'
          text={`Atual ${(appOutdated ? version : currentIntegraVersion)}`}
        />
        <Chip
          color={theme.colors.info}
          variant='outlined'
          text={`Disponível ${(appOutdated ? lastAppVersion : lastIntegraVersion)}`}
          containerStyle={{ marginLeft: 8 }}
        />
      </HStack>
    </HStack>

const makeIntegraOutdated = (): JSX.Element =>
  <HStack justify='center' items='center' style={{ backgroundColor: theme.colors.errorContainer }}>
    <Chip text={`${(appOutdated ? 'Portal' : 'IntegraService')} desatualizado`} color={theme.colors.error} />
    <Text variant="subtitle1" style={{ 
      padding: 12,
      fontWeight: '500',
      textTransform: 'uppercase', color: theme.colors.error
    }} >
      Existe uma versão nova disponível, contate o suporte para atualização
    </Text>
    <HStack spacing={8}>
      <Chip 
        variant='outlined'
        text={`Atual ${(appOutdated ? version : currentIntegraVersion)}`}
      />
      <Chip
        color={theme.colors.info}
        variant='outlined'
        text={`Disponível ${(appOutdated ? lastAppVersion : lastIntegraVersion)}`}
        containerStyle={{ marginLeft: 8 }}
      />
    </HStack>
  </HStack>

  return (
    <>
    {appOutdated
      ? makeAppOutdated()
      : integraOutdated
        ? makeIntegraOutdated()
        : undefined
    }
    </>
  )
}
